import React from 'react';
import type { ButtonProps } from 'antd';
import * as S from './styles';

export const Button = ({ children, ...props }: Readonly<ButtonProps>) => {
	return <S.ButtonWrapper {...props}>{children}</S.ButtonWrapper>;
};
